import { createContext, useContext } from 'react';

import { useOrderDetails } from './order-details.hook';

type OrderContextType = ReturnType<typeof useOrderDetails>;

const OrderDetailsContext = createContext<OrderContextType | null>(null);

export const OrderDetailsProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const value = useOrderDetails();
    return (
        <OrderDetailsContext.Provider value={value}>
            {children}
        </OrderDetailsContext.Provider>
    );
};

export const useOrderDetailsContext = () => {
    const context = useContext(OrderDetailsContext);
    if (!context) {
        throw new Error(
            'useOrderDetailsContext must be used within an OrderDetailsProvider',
        );
    }
    return context;
};
